import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { DevCenterOverridesClient } from './client.js';

export function useDevCenterOverridesClient(): DevCenterOverridesClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(
    () => new DevCenterOverridesClient(httpClient),
    [httpClient]
  );
  return usePanoramaMethodLogger(client);
}
